export default "__VITE_ASSET__BlxvHY5$__"